import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import featureImage from "../../static/images/heading.png"
import thumbnailMentor from "../../static/images/mentor.png"
import thumbnailGrowth from "../../static/images/growth.png"
import thumbnailResume from "../../static/images/resume.png"
import thumbnailFriends from "../../static/images/friends.png"

import honeyfiLogo from "../../static/images/honeyfiLogo.png"
import endsandstemsLogo from "../../static/images/endsandstemsLogo.png"
import opengrantsLogo from "../../static/images/opengrantsLogo.png"
import stacheLogo from "../../static/images/stacheLogo.png"
import bloombrasLogo from "../../static/images/bloombrasLogo.png"
import winnieLogo from "../../static/images/winnieLogo.png"
import fanalyzeLogo from "../../static/images/fanalyzeLogo.png"
import stringLogo from "../../static/images/stringLogo.png"
import backgroundImg from "../../static/images/background.png"



const IndexPage = () => (
    <Layout>
        <SEO title="Find an internship around your passion"/>

        <div className={"page-header home"}>
            <h1>Get a Headstart on your Passion</h1>
            <p>Internmatch is a career accelerator program by Nasdaq Entrepreneurial Center and California Community Colleges. <br/>Advance your career through thoughtfully crafted remote internships. </p>
            <img alt={"Dashboard"} src={featureImage}/>
        </div>

        <div className={"container"}>
            <div className={"features"}>
                <div className={"feature__item"}>
                    <div className={"row"}>
                        <div className={"col-6 first"}>
                            <div className={"thumbnail"}>
                                <img alt={"Mentor"} src={thumbnailMentor}/>
                            </div>
                        </div>

                        <div className={"col-6"}>
                            <div className={"feature__content"}>
                                <h2>Learn in Real Time</h2>
                                <p>Internmatch connects your passions and interest to startup companies that are a perfect internship fit. During your internship our team will work with you to help you maximize your career growth.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"feature__item"}>
                    <div className={"row"}>
                        <div className={"col-6"}>
                            <div className={"feature__content"}>
                                <h2>Grow your skills</h2>
                                <p>Grow your skills working directly with industry leaders, guiding you through all the nuances of building a business. </p>
                            </div>
                        </div>

                        <div className={"col-6 first"}>
                            <div className={"thumbnail"}>
                                <img alt={"Growth"} src={thumbnailGrowth}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"feature__item"}>
                    <div className={"row"}>
                        <div className={"col-6 first"}>
                            <div className={"thumbnail"}>
                                <img alt={"Resume"} src={thumbnailResume}/>
                            </div>
                        </div>

                        <div className={"col-6"}>
                            <div className={"feature__content"}>
                                <h2>Strengthen resume</h2>
                                <p>You'll have clear goals with tangible outcomes during your internship that will supercharge your resume with in-demand skills.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"feature__item"}>
                    <div className={"row"}>
                        <div className={"col-6"}>
                            <div className={"feature__content"}>
                                <h2>Grow business network</h2>
                                <p>Internmatch connects you to a community of students and business people that will help you grow your career and reach your goals.</p>
                            </div>
                        </div>

                        <div className={"col-6 first"}>
                            <div className={"thumbnail"}>
                                <img alt={"Friends"} src={thumbnailFriends}/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div className={"call-to-action"}>
            <div className={"container"}>
                <div className={"call-to-action__content"}>
                    <h2>Apply To Internmatch</h2>
                    <p>Apply to Nasdaq Entrepreneurial Center's exclusive Internship Program that teaches you real world skills and matches you with amazing companies.</p>
                    <p>Deadline to Apply is Monday, September 14th @ 5:00 PM PST</p>
                </div>

                <div className={"button"}>
                    <a href="https://thenasdaqcenter.typeform.com/to/SKldOQR2#source=site2" target={"_blank"}>Apply</a>
                </div>
            </div>
        </div>

        <div className={"student-voices"}>
            <div className={"container"}>
                <div className={"student-voices__content"}>
                    <h2>What students are saying</h2>
                    <p>"As a business student, any kind of experience in the field that you're pursuing would be beneficial. However, the opportunity to have a broader impact on a company like an early stage startup doesn't come often. By being a part of this internmatch program, I have tackled tasks and projects that challenged me to step out of my comfort zone. I believe that I have learned more technical skills, but also strengthened soft skills like time management and communication during a remote internship. My grasp of business practice through this internship will help me to build connections and solidify my understanding of entrepreneurship."</p>
                    <p>-Pauline, CCSF</p>
                    <div className={"student-voices-img__content"}>
                    </div>
                </div>
            </div>
        </div>

        

        <div className={"container"}>
            <div className={"startup"}>
                <div className={"row"}>
                    <div className={"startup__content"}>
                        <h2>Companies hosting students</h2>
                        <img src={endsandstemsLogo}/>
                        <img src={honeyfiLogo}  />
                        <img src={opengrantsLogo} />
                        <img src={winnieLogo}  />
                        <img src={bloombrasLogo}  />
                        <img src={stacheLogo}  />
                        <img src={fanalyzeLogo}  />
                        <img src={stringLogo}/>
                        
                        <p>and many more</p>
                    </div>
                </div>
            </div>
        </div>
                  
    </Layout>
)

export default IndexPage
